import { useState, useCallback } from 'react';
import { DateRange } from 'react-day-picker';

import DateRangePicker from './date-range-picker';

type Props = {
  fromFieldName: string;
  toFieldName: string;
  isRequired?: boolean;
  initialFromValue?: string | null;
  initialToValue?: string | null;
  minimumStartDate?: Date;
  maximumEndDate?: Date;
};

const DatePickerRangeFields = ({
  fromFieldName,
  toFieldName,
  initialFromValue,
  initialToValue,
  minimumStartDate,
  maximumEndDate,
}: Props) => {
  const [range, setRange] = useState<DateRange>({
    from: initialFromValue ? new Date(initialFromValue) : new Date(),
    to: initialToValue ? new Date(initialToValue) : new Date(),
  });

  const { from, to } = range;

  const handleFromChange = useCallback(
    (range: DateRange) => {
      setRange(range);
    },
    [setRange]
  );

  return (
    <DateRangePicker
      fromFieldValue={from}
      toFieldValue={to}
      fromField={fromFieldName}
      toField={toFieldName}
      selectedDays={{ from, to }}
      disabledDays={
        minimumStartDate && maximumEndDate
          ? [{ before: minimumStartDate }, { after: maximumEndDate }]
          : undefined
      }
      fromMonth={minimumStartDate}
      toMonth={maximumEndDate}
      onRangeChange={date => handleFromChange(date)}
    />
  );
};

export default DatePickerRangeFields;
